import {
    Firestore,
    doc,
    setDoc,
    getDocs,
    query,
    collection,
    orderBy,
    updateDoc,
    deleteDoc,
} from 'firebase/firestore'
import type { StorageModuleDeps } from '~common/storage/types'

export interface Shortcut {
    id?: string
    title: string
    url: string
    lastActive: number
}

export class ShortcutsStorageModule {
    constructor(private deps: StorageModuleDeps) {}

    async getShortcuts(): Promise<Shortcut[]> {
        const uid = this.deps.ensureAuthenticated()
        const q = query(
            collection(this.deps.db, 'users', uid, 'shortcuts'),
            orderBy('lastActive', 'desc'),
        )
        const snapshot = await getDocs(q)
        return snapshot.docs.map((d) => ({
            id: d.id,
            ...(d.data() as Omit<Shortcut, 'id'>),
        }))
    }

    async addShortcut(data: { title: string; url: string }): Promise<string> {
        const uid = this.deps.ensureAuthenticated()
        const shortcutRef = doc(
            collection(this.deps.db, 'users', uid, 'shortcuts'),
        )
        const id = shortcutRef.id
        await setDoc(shortcutRef, {
            ...data,
            lastActive: Date.now(),
        })
        return id
    }

    async updateShortcut(
        id: string,
        data: { title: string; url: string },
    ): Promise<void> {
        const uid = this.deps.ensureAuthenticated()
        await updateDoc(doc(this.deps.db, 'users', uid, 'shortcuts', id), {
            ...data,
        })
    }

    async deleteShortcut(id: string): Promise<void> {
        const uid = this.deps.ensureAuthenticated()
        await deleteDoc(doc(this.deps.db, 'users', uid, 'shortcuts', id))
    }
}
